import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
    this.loadYouTubeAPI();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
    if (this.player) {
      this.player.destroy();
    }
  }

  setVars() {
    super.setVars();
    this.player = null;
    this.canSeek = false;
    this.circleColors = ['#EF8DA5', '#E2C3A6'];
    this.animationPatterns = [
      // this.youtubeContainer (index 0)
      [
        { x: -35.335805050091516, y: 67.25762125453326, rotation: -40.357555398242894, arcFactor: -0.8409369981836137 },
        { x: -12.10755319368364, y: 66.39338576908126, rotation: -63.181764189061575, arcFactor: -0.629665284202183 },
        { x: 72.82889681418281, y: -20.819501834077357, rotation: -16.93456714669931, arcFactor: 0.6494315533941549 },
        { x: 71.82498291365683, y: -20.87164169355858, rotation: 54.103831475109345, arcFactor: 0.6294051279974883 },
      ],
      // this.circle1 (index 1)
      [
        { x: 25.129235526530554, y: 72.36887029852483, rotation: -88.1696547025224, arcFactor: 0.9866189508188468 },
        { x: -3.2946257288104963, y: 62.801638465457806, rotation: -50.355035040974734, arcFactor: 0.6956556808348756 },
        { x: -58.34494368830058, y: 33.549839723607576, rotation: 46.18583990709788, arcFactor: -0.6134051182447862 },
        { x: -64.43731059630419, y: -8.756340178976979, rotation: -73.6566829129633, arcFactor: 0.7976979087260645 },
      ],
      // this.circle2 (index 2)
      [
        { x: 37.20384806644083, y: -24.92962388942815, rotation: -21.667736377904312, arcFactor: 0.9556630556193704 },
        { x: -8.499802120366468, y: -69.28895963331246, rotation: -23.004981756843684, arcFactor: 0.6254884419280584 },
        { x: -16.373592247795553, y: -62.57113513542436, rotation: 55.92366817111751, arcFactor: 0.45970138186959075 },
        { x: 70.2599300052938, y: -30.10090961883402, rotation: 44.243314475464906, arcFactor: 0.5690060195166805 },
      ],
      // this.circle3 (index 3)
      [
        { x: -33.69936139052538, y: -73.35753082384258, rotation: 13.53449839057988, arcFactor: 0.9918178184763236 },
        { x: -47.04394034223238, y: -42.39391161457271, rotation: -67.17382523390576, arcFactor: 0.6472479090460647 },
        { x: -39.21643449833921, y: -32.56693295077911, rotation: 3.090388215917952, arcFactor: 0.805605518176107 },
        { x: -5.778409511730359, y: -61.12590948158451, rotation: 11.096769623459972, arcFactor: 0.7700100579738214 },
      ],
    ];
  }

  setDom() {
    super.setDom();
    this.circle1 = document.querySelector('main.top .hero .circle1');
    this.circle2 = document.querySelector('main.top .hero .circle2');
    this.circle3 = document.querySelector('main.top .hero .circle3');
    this.youtubeContainer = document.querySelector('main.top .hero .video_container');
    this.heroVideo = this.youtubeContainer?.querySelector('video');
    this.kvStill = this.youtubeContainer?.querySelector('.kv_still');

    this.h1ItemAll = document.querySelectorAll('main.top .hero h1 .item');
    this.h1ItemChildAll = document.querySelectorAll('main.top .hero h1 .item .item_child');
    this.h1ItemCircleAll = document.querySelectorAll('main.top .hero h1 .item .item_circle');
    this.h1SubTit = document.querySelector('main.top .hero .circle3 h1 .sub_tit');

    this.pack.initRandomPop(
      this.h1ItemAll,
      this.h1ItemCircleAll,
      this.h1ItemChildAll,
      this.circleColors
    );

    // アニメーション開始まで隠しておく
    gsap.set([this.circle1, this.circle2, this.circle3, this.youtubeContainer], {
      scale: 0,
    });

    this.section1 = document.querySelector('main.top .section1');
    this.heroCurve = document.querySelector('main.top .hero #curve-svg1');
  }

  initEvents() {
    super.initEvents();
    // YouTube APIが読み込まれなかった場合のフォールバック
    setTimeout(() => {
      if (!this.canSeek) this.onVideoReady();
    }, 8000);
  }

  loadYouTubeAPI() {
    if (window.YT && window.YT.Player) {
      this.createPlayer();
      return;
    }

    const prevCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof prevCallback === 'function') prevCallback();
      this.createPlayer();
    };

    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  createPlayer() {
    this.player = new YT.Player('player', {
      videoId: 'jMRkM4d8l4A',
      playerVars: {
        autoplay: 1,
        mute: 1,
        loop: 0,
        playsinline: 1,
        controls: 0,
        disablekb: 1,
        modestbranding: 1,
        rel: 0,
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
      },
    });
  }

  onPlayerReady(event) {
    event.target.playVideo();
    event.target.mute();
  }

  onPlayerStateChange(event) {
    // 初回の再生/バッファリング開始 = シーク可能と判断
    if (!this.canSeek && (event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.BUFFERING)) {
      this.canSeek = true;
      if (this.pack.common.waitStartSite) this.pack.common.startSite();
    }

    if (event.data === YT.PlayerState.ENDED) {
      if (this.kvStill) this.kvStill.classList.add('show');
    }
  }

  showKvStillBeforeEnd() {
    if (!this.player || !this.kvStill || this.kvStill.classList.contains('show')) return;
    if (typeof this.player.getCurrentTime !== 'function') return;
    if (this.player.getPlayerState() !== YT.PlayerState.PLAYING) return;

    const duration = this.player.getDuration();
    if (!duration) return;

    if (this.player.getCurrentTime() >= duration - 0.5) {
      this.kvStill.classList.add('show');
    }
  }

  onVideoReady() {
    this.canSeek = true;
    // Common.js側で既に待機状態に入っている場合は、ここからサイト表示を開始する
    if (this.pack.common.waitStartSite) {
      this.pack.common.startSite();
    }
  }

  start() {
    gsap.delayedCall(.2, ()=>{
      this.playHeroPop([
        this.youtubeContainer,
        this.circle1,
        this.circle2,
        this.circle3,
      ]);

      if (this.player) {
        this.player.seekTo(1);
      }

      gsap.delayedCall(.6, ()=>{
        this.pack.playRandomPop(this.h1ItemAll, this.h1ItemCircleAll, this.h1ItemChildAll);
        this.h1SubTit.classList.add('show');

        this.pack.common.lockScroll = false;
        if (this.sw < this.pack.BP) document.documentElement.classList.remove('lock');

        this.showWithOptionalTransitionSkip(this.section1);
        this.showWithOptionalTransitionSkip(this.heroCurve);
        // this.pack.curve.animateToFlat();
      });
    });
  }

  showWithOptionalTransitionSkip(target) {
    if (!target) return;

    // #new-uniformで訪問した場合は、スライドインモーションをスキップして即表示する
    if (window.location.hash === '#new-uniform') {
      target.classList.add('notransition');
      target.classList.add('show');
      // 次フレームでnotransitionを外し、以降の通常のtransitionには影響させない
      requestAnimationFrame(() => {
        target.classList.remove('notransition');
      });
      return;
    }

    target.classList.add('show');
  }

  playHeroPop(targets) {
    targets.forEach((target, index) => {
      if (!target) return;

      // 定義済みのパターンからランダムに取得
      const patterns = this.animationPatterns[index];
      const pattern = patterns[Math.floor(Math.random() * patterns.length)];
      const { x: randomX, y: randomY, rotation: randomRotate, arcFactor } = pattern;

      const delay = index * 0.1; // 順番に0.1秒ずつ遅らせる

      let dr = 2.0;

      // 初期位置をセット
      gsap.set(target, {
        x: `${randomX}rem`,
        y: `${randomY}rem`,
        rotation: randomRotate,
        scale: 0,
      });

      const controlX = randomX / 2 + randomY * arcFactor;
      const controlY = randomY / 2 - randomX * arcFactor;

      const animObj = { t: 0, rotation: randomRotate, scale: 0 };

      gsap.to(animObj, {
        t: 1,
        rotation: 0,
        scale: 1,
        duration: dr,
        ease: 'quart.out',
        delay: delay,
        onUpdate: () => {
          const t = animObj.t;
          const it = 1 - t;
          // 2次ベジェ曲線
          const x = it * it * randomX + 2 * it * t * controlX;
          const y = it * it * randomY + 2 * it * t * controlY;
          gsap.set(target, {
            x: `${x}rem`,
            y: `${y}rem`,
            rotation: animObj.rotation,
            scale: animObj.scale,
          });
        },
      });
    });
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {
    this.showKvStillBeforeEnd();
  }

  executeResize() {
    super.executeResize();
  }
}